export default __webpack_public_path__ + "static/media/rodrigo-calderon.52d33ea5.png";